import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const TaxPulseDashboardPage = lazy(() => import("@/features/dashboard/pages/taxpulse-dashboard"));

export const Route = createFileRoute("/(app)/dashboard/taxpulse")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <TaxPulseDashboardPage />
    </Suspense>
  ),
});
